import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getProfileTypes } from './subscriptionThunk';
import { ProfileTypes } from '../../../interfaces/Subscription';
import { IOptions } from '../../../interfaces/Rights';

interface subscriptionState {
    loading: "idle" | "pending" | "succeeded" | "failed";
    profiles: ProfileTypes[] | null;
    profilesOptions: IOptions[] | []
}

const initialState: subscriptionState = {
    loading: 'idle',
    profiles: null,
    profilesOptions: []
}

export const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getProfileTypes.pending, (state) => {
            state.loading = "pending";
        });
        builder.addCase(getProfileTypes.fulfilled, (state, action) => {
            state.loading = "succeeded";
            state.profiles = action.payload.profile;
            state.profilesOptions = action.payload.profile.map((p: ProfileTypes) => ({
                id: p.id,
                value: p.nombre
            }));
        });
        builder.addCase(getProfileTypes.rejected, (state) => {
            state.loading = "failed";
        });
    }
})

export const { } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;